export default "__VITE_ASSET__c_IEZv_z__"